import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { ListQueryKey, Urls } from '../constant';
import { useMutation } from '@tanstack/react-query';
import { Project } from '../types';

export interface UpdateResponse extends Response {
  data: null;
}

//
export const update = (data: Partial<Project>): Promise<UpdateResponse> => {
  return axios.post(Urls.updateUrl, {
    ...data,
    project_id: data.id,
  });
};

type UseUpdateOptions = {
  config?: MutationConfig<typeof update>;
};

//
export const useUpdate = ({ config }: UseUpdateOptions) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: update,
    ...config,
  });
};
